module.exports = __webpack_public_path__ + "static/img/Goddess of Victory Nikke.65776d2b.png";